import { render, staticRenderFns } from "./borrowingForm.vue?vue&type=template&id=735ed421&scoped=true&"
import script from "./borrowingForm.vue?vue&type=script&lang=js&"
export * from "./borrowingForm.vue?vue&type=script&lang=js&"
import style0 from "./borrowingForm.vue?vue&type=style&index=0&id=735ed421&prod&lang=less&scoped=true&"
import style1 from "./borrowingForm.vue?vue&type=style&index=1&id=735ed421&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735ed421",
  null
  
)

export default component.exports